import React, { useEffect, useState, useMemo } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField";
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from 'framer-motion'

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const Enquiries = () => {
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [userList, setUserList] = useState([])

    useEffect(() => {
        setLoading(true)
        API.get('/common/getEnquiries').then((userRes) => {
            if (userRes.status === 200) {
                setUserList(userRes.data.data)
                setLoading(false)
            }
        })
    }, [])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: 'Name', selector: row => row.name, sortable: true },
        { name: 'Email', selector: row => row.email, sortable: true },
        { name: 'Mobile', selector: row => row.mobile, sortable: true },
        { name: "Message", selector: row => row.message, sortable: true, wrap: true }
    ], [])

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return userList.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [userList, filter])

    const SubHeader = useMemo(() => (
        <div className="table-toolbar">
            <div className="toolbar-actions">
                <span className="status-pill status-pill--warning">{filteredcasedetails.length} enquiries</span>
            </div>
            <div className="toolbar-actions">
                <InlineTextField label={"Enquiries"} placeholder={"Search name, email, or mobile"} value={filter} setValue={setFilter} />
            </div>
        </div>
    ), [filter, filteredcasedetails.length])

    return (
        <motion.div className="space-y-5">
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="datatable-shell panel-card h-full w-full overflow-hidden">
                    <DataTable
                        title="Enquiries"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
        </motion.div>
    )
}

export default Enquiries
